module.exports = __webpack_public_path__ + "img/banner.f63e7a57.png";